import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: 'Raleway', sans-serif;

  @media (max-width: ${screenSizes.tablet}) {
    padding: 0rem;
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 0rem;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  margin-bottom: 2rem;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  color: #475569;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background-color: #f8fafc;
    border-color: #cbd5e1;
  }

  i {
    font-size: 0.875rem;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;

  @media (max-width: ${screenSizes.mobile}) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  color: #64748b;
  font-size: 1.125rem;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 5rem 2rem;
  background: white;
  border-radius: 1.5rem;
  border: 2px dashed #cbd5e1;

  i {
    font-size: 3rem;
    color: #cbd5e1;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.5rem;
    color: #64748b;
    margin: 0 0 0.5rem 0;
  }

  p {
    color: #94a3b8;
    margin: 0;
  }
`;

export const SectionContainer = styled.div`
  margin-bottom: 3rem;

  &:last-child {
    margin-bottom: 0;
  }
`;
